module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE2SURBVHgBrZI7TsNAEIZnNpGAKnZESpIRlpChgo4O5wZwAuAG3CDxCRAnIEfgBoGOMjTITdBAbRGnCo09eE0WHCuBRcpfeJ7+dvYBsAZhOWjvHvQAxFHZLGTmBCxV/wHsXyPKlfaltkW5ObOF1PSH6NABld6V8n7DbU2nk/jRBqK+zIdTLSBCj4icf0A2l+0/sT2XAsI8ypvlfmGSVLpgKfX9E0JYLmRKnYOlasZJ3mNuNFtufufHc2jgNrc5mcRPf0HUQpBu9EFgZGIBHBifyKe259/ueHunVQhWE7pZFA7zCiHIpWZloAIUCXSugAv2316ew5UQA8qfIeWjdMrTVMSYzo70DdaXVjlibTqeP4TVIuOoX5rgdRx1iy0JcLUmADfmHSFYijz/IgM4ma/8wONoAOvUJ3/AYxnQGBqZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/call1.png
// module id = 9d+P
// module chunks = 0